import { render, staticRenderFns } from "./CreateBoat.vue?vue&type=template&id=708cbf30&"
import script from "./CreateBoat.vue?vue&type=script&lang=js&"
export * from "./CreateBoat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateBoat.vue"
export default component.exports